import { Form } from '@components/form/Form'
import { FormTextfield } from '@components/form/FormTextfield'
import { useAuthenticator } from '@features/auth/utils/useAuthenticator'
import { zodResolver } from '@hookform/resolvers/zod'
import LoadingButton from '@mui/lab/LoadingButton'
import Box from '@mui/material/Box'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'

const formSchema = z
  .object({
    username: z.string().min(3, { message: 'Username must be at least 3 characters long.' }),
    password: z.string().min(8, { message: 'Password must be at least 8 characters long.' }),
  })
  .required()

type FormValues = z.infer<typeof formSchema>

export function LoginForm() {
  const { login, isLoadingAuth } = useAuthenticator()
  const { t } = useTranslation()

  const loginForm = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      username: '',
      password: '',
    },
  })

  const onSubmit = (values: FormValues) => {
    void login({ username: values.username, password: values.password })
  }

  return (
    <form
      onSubmit={loginForm.handleSubmit(onSubmit)}
      method="post"
    >
      <Form {...loginForm}>
        <Box
          display="grid"
          gridTemplateColumns="1fr"
          gap={2}
          sx={{ minWidth: 300 }}
        >
          <FormTextfield
            name="username"
            label={t('login_page.username')}
          />
          <FormTextfield
            name="password"
            label={t('login_page.password')}
            type="password"
          />
          <LoadingButton
            type="submit"
            variant="contained"
            color="primary"
            loading={isLoadingAuth}
          >
            {t('login_page.sign_in')}
          </LoadingButton>
        </Box>
      </Form>
    </form>
  )
}
